// extracted by mini-css-extract-plugin
export default {"ipad_layout":"index_ipad_layout_B3tTi","layout":"index_layout_73le8"};